import Vue from 'vue'

import { extend, localize } from 'vee-validate'
import { required, max, between, oneOf } from 'vee-validate/dist/rules'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import browserLocale from '@/i18n'
import de from 'vee-validate/dist/locale/de.json'
import en from 'vee-validate/dist/locale/en.json'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

//install already available rules from VeeValidate
extend('required', required)
extend('max', max)
extend('between', between)
extend('oneOf', oneOf)

extend('half_step', {
  validate(value) {
    return (parseFloat(value) * 2) % 1 === 0
  },
  message: 'Only 0.5 steps are allowed (e.g. 1, 1.5, 2)'
})

// Install and customize all localizations error messages
localize({
  de: {
    messages: { ...de.messages, half_step: 'Nur 0,5-Schritte sind erlaubt (z.B. 1, 1,5, 2)' },
    names: {
      task_start: 'Datum',
      comment: 'Kommentar',
      from: 'Von',
      visibility: 'Sichtbarkeit',
      duration: 'Stunden',
      description: 'Beschreibung',
      results: 'Ergebnisse',
      hours: 'Stunden',
      overallStatus: 'Allgemeiner Status',
      workLoad: 'Arbeitsbelastung',
      quality: 'Qualität',
      teamSpirit: 'Teamgeist',
      schedule: 'Zeitplan',
      budget: 'Budget',
      risks: 'Risiken',
      identifiedRisks: 'Identifizierte Risiken',
      cause: 'Ursache',
      counterMeasures: 'Gegenmaßnahmen',
      consequences: 'Konsequenzen',
      firstPriority: 'Erste Priorität',
      secondPriority: 'Zweite Priorität',
      thirdPriority: 'Dritte Priorität',
      teamMember: 'Teammitglied',
      preferences: 'Vorlieben',
      content: 'Inhalt'
    }
  },
  en: {
    messages: { ...en.messages, half_step: 'Only 0.5 steps are allowed (e.g. 1, 1.5, 2)' },
    names: {
      task_start: 'date',
      comment: 'comment',
      from: 'from',
      visibility: 'visibility',
      duration: 'hours',
      description: 'description',
      results: 'results',
      hours: 'hours',
      overallStatus: 'Overall status',
      workLoad: 'Work load',
      quality: 'Quality',
      teamSpirit: 'Team spirit',
      schedule: 'Schedule',
      budget: 'Budget',
      risks: 'Risks',
      identifiedRisks: 'Identified risks',
      cause: 'cause',
      counterMeasures: 'counter measures',
      consequences: 'consequences',
      firstPriority: 'First priority',
      secondPriority: 'Second priority',
      thirdPriority: 'Third priority',
      teamMember: 'Team member',
      preferences: 'Preferences',
      content: 'content'
    }
  }
})

//set VeeValidate language to the user's browser language with English as fallback
let LOCALE = browserLocale.locale
localize(LOCALE)

/* A simple get/set interface to manage our locale in components.
This is not reactive, so don't create any computed properties/watchers of it.*/
Object.defineProperty(Vue.prototype, 'locale', {
  get() {
    return LOCALE
  },
  set(val) {
    LOCALE = val
    localize(val)
  }
})
